import { useSelector } from "react-redux";
import { RootState } from "@/store/store";
import { useState, useEffect } from "react";
import { syncOfflineRequests } from "@/utils/syncManager";

const NetworkStatus = () => {
  const isOnline = useSelector((state: RootState) => state.network.isOnline);
  const isSyncing = useSelector((state: RootState) => state.network.isSyncing);

  const [position, setPosition] = useState({ x: window.innerWidth / 2, y: 20 });
  const [isDragging, setIsDragging] = useState(false);
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (isOnline) {
      setPosition({ x: window.innerWidth / 2, y: 20 });
    }
  }, [isOnline]);

  const startDrag = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    setIsDragging(true);
    setOffset({
      x: e.clientX - position.x,
      y: e.clientY - position.y,
    });
  };

  const onDrag = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    if (isDragging) {
      setPosition({
        x: e.clientX - offset.x,
        y: e.clientY - offset.y,
      });
    }
  };

  const stopDrag = () => {
    setIsDragging(false);
  };

  useEffect(() => {
    if(isOnline && !isSyncing) {
      syncOfflineRequests();
    }
  },[isOnline, isSyncing])

  if (isOnline && !isSyncing) return null;

  const ConnectionStatus = () => {
    return isSyncing ? (
      <span className="text-[14px]">🔄 Syncing offline data...</span>
    ) : (
      <span className="text-[14px]">⚠️ No Internet Connection. Some features may not work.</span>
    );
  };

  return (
    <div
      className="fixed text-[#000] p-[10px] text-center text-[14px] font-bold z-[9999] cursor-move shadow-md"
      style={{
        top: "76px",
        left: position.x + "px",
        width: "60%",
        maxWidth: "400px",
        borderRadius: "8px",
        userSelect: "none",
        transform: "translate(-50%, 0)",
        backgroundColor: isSyncing ? "#4CAF50" : "#CBA300",
      }}
      onMouseDown={startDrag}
      onMouseMove={onDrag}
      onMouseUp={stopDrag}
      onMouseLeave={stopDrag}
    >
      <p className="m-0">
        <ConnectionStatus />
      </p>
    </div>
  );
};

export default NetworkStatus;
